import React from "react";
import { makeStyles } from "@mui/styles";
import BaseDrawer from "../modals/mobile/BaseDrawer";
import { Box, Typography } from "@mui/material";
import ColorSwitcher, { StyledColorToggleButton } from "../ColorSwitcher";
import GradientButton from "../gradients/GradientButton";

const useStyles = makeStyles((theme) => ({
  header: {
    zIndex: ({ drawerOpen }) => (drawerOpen ? "2" : "inherit"),
    backgroundColor: theme.palette.primary.contrastText,
    paddingTop: ({ drawerOpen }) => (drawerOpen ? "0" : theme.spacing(3)),
    paddingBottom: ({ drawerOpen }) => (drawerOpen ? theme.spacing(4) : theme.spacing(2)),
    paddingInline: theme.spacing(2),
    display: "flex",
    position: "relative",
    justifyContent: "space-between",
    alignItems: "center",
    minHeight: ({ drawerOpen }) => (drawerOpen ? 100 : 72),
    lineHeight: 1.2,
    gap: "10px",
  },
  headerGradient: {
    top: 0,
    left: 0,
    right: 0,
    height: 8,
    position: "absolute",
    background:
      "linear-gradient(90deg, rgba(204,48,69,1) 0%, rgba(234,96,165,1) 20%, rgba(245,225,124,1) 40%, rgba(79,173,91,1) 60%, rgba(50,152,196,1) 80%, rgba(175,145,189,1) 100%)",
  },
  title: {
    fontSize: 18,
    fontWeight: 700,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    flexGrow: 1,
  },
  outlineSwitch: {
    outline: "2px solid black",
    borderRadius: "50%",
  },
}));

export default function MobileHeader({ title, children, data, drawerOpen }) {
  const classes = useStyles({ drawerOpen });

  const [open, setOpen] = React.useState(false);

  const currSwitchColor = data.swatches?.find((swatch) =>
    swatch.includes(data.variant.color.replaceAll(" ", "-").toLowerCase())
  );

  const handleMenageDrawer = () => {
    setOpen((prevState) => !prevState);
  };

  return (
    <header className={classes.header}>
      <span className={classes.headerGradient} />
      {!drawerOpen && (
        <div className={classes.outlineSwitch} onClick={handleMenageDrawer}>
          <StyledColorToggleButton
            value=""
            swatch={currSwitchColor}
            sx={{ height: "24px !important", width: "24px !important" }}
          />
        </div>
      )}
      <h1 className={classes.title}>{title}</h1>
      {children}
      {open && (
        <BaseDrawer headline="Select Color" onClose={handleMenageDrawer}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginBottom: "2rem",
              gap: "8px",
            }}
          >
            <Typography variant="body1" align="center">
              Select a color below to switch options
            </Typography>
            <Box sx={{ padding: "5rem 0" }}>
              <ColorSwitcher data={data} />
            </Box>
            <Typography variant="body1" align="center">
              Keep designing!
            </Typography>
            <GradientButton
              addStyle={{
                minWidth: "146px",
                minHeight: "45px",
                fontSize: "15px",
              }}
              onClick={handleMenageDrawer}
            >
              Continue
            </GradientButton>
          </Box>
        </BaseDrawer>
      )}
    </header>
  );
}
